<!-- 围栏设置 -->
<template>
  <div class="campus-announcement">
    <div class="rig-box" v-if="showbox">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="140px" class="demo-ruleForm">
        <el-form-item label="城市" prop="chengshiregion1">
          <el-select v-model="ruleForm.chengshiregion1" filterable placeholder="请选择省份" @change="chengshiClick()">
            <el-option :label="item.name" :value="item.id" v-for="item in dizhi1" ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-select v-model="ruleForm.chengshiregion2" filterable placeholder="请选择城市">
            <el-option :label="item.name" :value="item.id" v-for="item in dizhi2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="提醒" prop="autoNotify">
          <el-radio-group v-model="ruleForm.autoNotify">
            <el-radio label="是"></el-radio>
            <el-radio label="否"></el-radio>
          </el-radio-group>
        </el-form-item>  
        <el-form-item label="学校名称" prop="name">
          <el-input v-model="ruleForm.name"></el-input>
          <span class="jingwei-box" @click="huoqu">获取经纬度</span>
        </el-form-item>
        <el-form-item label="围栏半径(米)" prop="region">
          <el-select v-model="ruleForm.region" filterable placeholder="请选择活动区域" @change="banjingClick">
            <el-option :label="item.name" :value="item.value" v-for="item in banjing"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="经纬度" prop="">
          <el-input v-model="ruleForm.latitude1"></el-input>
        </el-form-item>
        <el-form-item label="" prop="">
          <el-input v-model="ruleForm.circleLat"></el-input>
        </el-form-item>
        <el-form-item label="学校WiFi设置" prop="">
          <div v-for="(item,index) in wifiList" style="" class="wifi-box">
            {{ item.label1 }}<el-input v-model="item.value1"></el-input>
            {{ item.label2 }}<el-input v-model="item.value2" style="margin-left: 8px;"></el-input> <br>
          </div>
        </el-form-item>

        <div class="ditu-box">
          <div class="ditu-zi">
            <Mapview 
              :status="status" 
              :addressSplitJoint="addressSplitJoint" 
              :banjingValue="banjingValue"
              :detailsObj="detailsObj"
              @jingweidu="jingweidu"
              ></Mapview>
          </div>
          <div class="rig-ditu"></div>
        </div>

        <el-form-item>
          <el-button type="primary" class="addBtn" @click="submitForm('ruleForm')">立即创建</el-button>
          <el-button type="danger" @click="dialogVisible = true">删除此围栏</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="let-box">
      <el-tree :data="dataList" :props="defaultProps" @node-click="handleNodeClick"></el-tree>
    </div>
    <el-dialog
    v-model="dialogVisible"
    title="提示"
    width="30%"
    :before-close="handleClose"
  >
    <span>确定删除此围栏信息吗?</span>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="railInfoDeleteClick">
          确定
        </el-button>
      </span>
    </template>
  </el-dialog>
  </div>
</template>
  
<script>
import Mapview from "@/components/MapContainer.vue"
import { setSystemUserTree, } from '@/assets/api/api.js'
import { railInfoFind,railInfoUpdate,railInfoDelete,getRegionTree} from '@/assets/api/schoollog.js'

export default {
  components: {
    Mapview
  },
  data() {
    return {
      showbox:false,
      status: null,
      ruleForm: {
        name: '',
        autoNotify: true,
        chengshiregion1: '',
        chengshiregion2: '',
        region: '300',
        resource: '',
        latitude1:'',
        latitude2:'',
        circleLat: '',
      },
      shiDizhi: '',
      banjingValue: '',
      dizhi1: [
        // {
        //   name: '上海市',
        //   value:'8ea318e8-1e2d-4ff4-8966-7fb32b3a8178'
        // },
      ],
      dizhi2: [
        // {
        //   name: '上海市',
        //   value:'d2da4ae5-cbce-4849-a97c-a8852a444f15'
        // },
      ],
      banjing: [
        {
          name: '300',
          value: '300'
        },
        {
          name: '400',
          value: '400'
        },
        {
          name: '500',
          value: '500'
        },
      ],
      wifiList: [
        {
          label1: '01',
          value1: '',
          label2: '02',
          value2: '',
        },
        {
          label1: '03',
          value1: '',
          label2: '04',
          value2: '',
        },
        {
          label1: '05',
          value1: '',
          label2: '06',
          value2: '',
        },
        {
          label1: '07',
          value1: '',
          label2: '08',
          value2: '',
        },
        {
          label1: '09',
          value1: '',
          label2: '10',
          value2: '',
        },
        {
          label1: '11',
          value1: '',
          label2: '12',
          value2: '',
        },
        {
          label1: '13',
          value1: '',
          label2: '14',
          value2: '',
        },
       
      ],
      dataList: [
        
      ],
      defaultProps: {
        children: 'children',
        label: 'username'
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
        ],
        chengshiregion1: [
          { required: true, message: '请选择活动区域', trigger: 'change' }
        ],
        autoNotify: [
          { required: true, message: '请选择活动资源', trigger: 'change' }
        ],
      },
      addressSplitJoint: '',
      detailsObj: {},
      dataId: '',
      dialogVisible: false
    };
  },
  created() {
    this.status = '2'
    this.setSystemUserTree()
  },
  mounted() {
    this.getRegionTreeGet()
  },
  watch: {
    shiDizhi (value) {
      console.log(value,'监听');
      this.chengshiClick()
    }
    
  },
  methods: {
    chengshiClick () {
      console.log(this.ruleForm.chengshiregion1, '城市id');
      let params = {
        id: this.ruleForm.chengshiregion1
      }
      getRegionTree(params).then((res)=> {
        console.log(res,'县-区');
        this.dizhi2 = res.data.data.children
      }).catch((err)=> {
        console.log(err);
      })
    },
    getRegionTreeGet () {
      getRegionTree({}).then((res)=> {
        console.log(res,'市');
        this.dizhi1 = res.data.data.children
      }).catch((err)=> {
        console.log(err);
      })
    },
    railInfoDeleteClick () {
      railInfoDelete({id: this.dataId}).then((res)=> {
        console.log(res,'删除围栏');
        this.handleNodeClick() // 删除成功后从新调用查询
      }).catch((err) => {
        console.log(err);
      })
    },
    jingweidu (lng,lat) {
      this.ruleForm.latitude1 = lng
      this.ruleForm.circleLat = lat
    },
    handleNodeClick(data) {
      this.dataId = data.id
      let params = {
        id: data.id
      }
      railInfoFind(params).then((res)=> {
        console.log(res,'围栏信息-查询');
        let data = res.data.data
        // this.detailsObj = data  
        this.shiDizhi = data.provinceId
        if ( data.circleName ) {
          this.addressSplitJoint = data.provinceName+data.cityName+data.circleName
        } else {
          this.addressSplitJoint = ''
        }
        this.ruleForm.name = data.circleName
        this.ruleForm.chengshiregion1 = data.provinceId
        this.ruleForm.chengshiregion2 = data.cityId
        this.ruleForm.autoNotify = data.autoNotify? '是':'否'
        this.ruleForm.latitude1 = data.circleLat
        this.ruleForm.circleLat = data.circleLng
        this.wifiList[0].value1 = data.schoolMac1
        this.wifiList[0].value2 = data.schoolMac2
        this.wifiList[1].value1 = data.schoolMac3
        this.wifiList[1].value2 = data.schoolMac4
        this.showbox = true
      }).catch((err)=> { 
        console.log(err);
      })
    },
    setSystemUserTree() {
      let params = {
        userId: JSON.parse(localStorage.getItem('user')).id,
      }
      setSystemUserTree(params).then((res) => {
        console.log(res, '用户树--接口');
        this.dataList = res.data.data
   
      }).catch((err) => {
        console.log(err);
      })
    },
    submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            // alert('submit!');
            this.railInfoUpdate()
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
    railInfoUpdate () {
      let params = {
        id:this.dataId,
        autoNotify: this.ruleForm.autoNotify == '是'? true :false,
        // circleLat: this.ruleForm.latitude1, // 经度
        // circleLng: this.ruleForm.circleLat , // 纬读
        circleLat: this.ruleForm.circleLat, // 经度
        circleLng: this.ruleForm.latitude1 , // 纬读
        circleName: this.ruleForm.name, // 学校名字
        circleRadius: this.ruleForm.region, // 半径
        cityId: this.ruleForm.chengshiregion2, // 市ID
        provinceId: this.ruleForm.chengshiregion1, // 市ID
        type: '1',
        schoolMac1: this.wifiList[0].value1,
        schoolMac2: this.wifiList[0].value2,
        schoolMac3: this.wifiList[1].value1,
        schoolMac4: this.wifiList[1].value2,
        schoolMac5: '' ,
        schoolMac6: '' ,
        schoolMac7: '' ,
        schoolMac8: '' ,
        schoolMac9: '' ,
        schoolMac10: '' ,
        schoolMac11: '' ,
        schoolMac12: '' ,
        schoolMac13: '' ,
        schoolMac14: '' ,
        schoolMac15: '' ,
        schoolMac16: '' ,
        schoolMac17: '' ,
        schoolMac18: '' ,
        schoolMac19: '' ,
        schoolMac20: '' ,
        schoolMac21: '' ,
        schoolMac22: '' ,
        schoolMac23: '' ,
        schoolMac24: '' ,
        schoolMac25: '' ,
        schoolMac26: '' ,
        schoolMac27: '' ,
        schoolMac28: '' ,
        schoolMac29: '' ,
        schoolMac30: '' ,
      }
      
      railInfoUpdate(params).then((res)=> {
        console.log(res,'设置围栏');
        this.$message({
                    type: 'success',
                    message:'围栏设置成功'
                });
      }).catch((err)=> {
        console.log(err);
        this.$message({
                    type: 'error',
                    message: err.response.data.msg
                });
      })
    },
    huoqu () {
      if (this.ruleForm.chengshiregion1 != '' && this.ruleForm.chengshiregion2 != '' && this.ruleForm.name !='' ) {
        // console.log(this.ruleForm.chengshiregion1+this.ruleForm.chengshiregion2+this.ruleForm.name);
        let name1 = ''
        let name2 = ''
        for ( let item of this.dizhi1 ) {
          if (this.ruleForm.chengshiregion1 == item.value) {
            name1 = item.name
          }
        }
        for ( let item of this.dizhi2 ) {
          if (this.ruleForm.chengshiregion2 == item.value) {
            name2 = item.name
          }
        }
        this.addressSplitJoint = name1+name2+this.ruleForm.name
        console.log(this.addressSplitJoint);
      } else {
        this.$message({type: 'error', message: '查询失败! 请先选择地址,并输入学校'});
      }
    },
    banjingClick () {
      this.banjingValue = this.ruleForm.region
      console.log(this.ruleForm.region);
    },
  },
};
</script>

<style scoped lang="scss">
.campus-announcement {
  height: 96% /*no*/;
  background-color: #fff;
  display: flex;
  overflow: auto;
  .let-box {
    width: 75%;
    padding: 10px;
    padding-top: 50px;
    height: 90%;
    overflow: auto;
    // background-color: saddlebrown;
  }

  .rig-box {
    width: 75%;
    // background-color: silver;
    padding: 20px;
    padding-top: 60px;
    .jingwei-box {
      margin-left: 8px;
      // color: #1BC896;
      font-size: 16px;
      font-weight: 700;
      cursor: pointer;
    }
    .wifi-box {
      width: 100%;
      margin-bottom: 8px;
    }
    .addBtn{
      // background-color: #1BC896;
    }
    .ditu-box {
      display: flex;
      height: 350px; /*no*/
      margin-bottom: 15px;
      // background-color: ;
      // border: 1px solid saddlebrown;
      .ditu-zi {
        height: 350px; /*no*/
        width: 680px; /*no*/
        text-align: center;
        margin-left: 140px;
      }
      // .rig-ditu {
      //   width: calc(100% - 580px) ;
      //   // background-color: pink;
      // }
    }
    :deep() {
      .el-form-item--small .el-form-item__label {
        height: 35px;
        line-height: 35px;
        font-size: 16px;
      }
      .el-input__inner {
        font-size: 15px;
      }
      .el-input {
        width: 240px;
        height: 35px;
      }
      .el-radio.el-radio--small .el-radio__label {
        font-size: 16px;
        // color:#1BC896;

      }
      .el-radio.el-radio--small .el-radio__inner {
        width: 16px;
        height: 16px;
        // color:#1BC896;
        // background-color: #1BC896;
      }
      .el-select--small .el-select__wrapper{
          width: 245px !important;
          height: 38px;
        }
    }
  
  }
}</style>
